import { isAppMode } from "../../global/AppOverlay";
import { delay } from "../utilities/UtilityFunctions";
import ModalLoadingMessage from "./ModalLoadingMessage";
import { useEffect } from "react";

export default function RedirectModal({
  url,
  target,
  open,
  setOpen,
  message,
  ...rest
}) {
  const delayTime = rest?.delay || 1.5;
  const appMode = isAppMode();
  const redirect = async () => {
    await delay(delayTime * 1000);

    if (appMode) {
      window.open(url, "_blank");
    } else if (Boolean(target)) {
      window.open(url, "popup");
    } else {
      window.location.assign(url);
    }
    if (setOpen) {
      setOpen(false);
    }
  };
  useEffect(() => {
    if (url) redirect();

    // eslint-disable-next-line
  }, []);
  if (!open) return <></>;
  return <ModalLoadingMessage message={message || "Redirecting"} open />;
}
